import { render } from "./RichFilters.vue?vue&type=template&id=19109fec&scoped=true"
import script from "./RichFilters.vue?vue&type=script&lang=js"
export * from "./RichFilters.vue?vue&type=script&lang=js"

import "./RichFilters.vue?vue&type=style&index=0&id=19109fec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19109fec"]])

export default __exports__